import React from 'react';
import { AppContext } from '../../context/AppContext/context';

function usePiercingLocations() {
  const { state } = React.useContext(AppContext);
  const { piercingLocations } = state;
  return piercingLocations;
}

export default usePiercingLocations;
